<script setup lang="ts">
import { computed } from "vue";
import { HIGHLIGHT_POST, HIGHLIGHT_PRE } from "@/common/axshare/constants";

const props = defineProps<{
  taggedText: string;
}>();

const segments = computed(() => {
  const out: { text: string; hl: boolean }[] = [];
  let rest = props.taggedText;

  let idx = rest.indexOf(HIGHLIGHT_PRE);

  while (idx !== -1) {
    if (idx > 0) {
      out.push({ text: rest.slice(0, idx), hl: false });
    }

    rest = rest.slice(idx + HIGHLIGHT_PRE.length);

    const endIdx = rest.indexOf(HIGHLIGHT_POST);
    if (endIdx === -1) {
      out.push({ text: HIGHLIGHT_PRE + rest, hl: false });
      rest = "";
      break;
    }

    out.push({ text: rest.slice(0, endIdx), hl: true });

    rest = rest.slice(endIdx + HIGHLIGHT_POST.length);

    idx = rest.indexOf(HIGHLIGHT_PRE);
  }

  if (rest) {
    out.push({ text: rest, hl: false });
  }

  return out;
});
</script>

<template>
  <div>
    <template v-for="(seg, i) in segments" :key="i">
      <strong v-if="seg.hl">{{ seg.text }}</strong>
      <template v-else>
        {{ seg.text }}
      </template>
    </template>
  </div>
</template>
